import { render, staticRenderFns } from "./JobItemLong.vue?vue&type=template&id=22800120&"
import script from "./JobItemLong.vue?vue&type=script&lang=js&"
export * from "./JobItemLong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports